// SR 启动
// SR 加载核心模块
SR.lifecycle.launch();
// SR dom ready
SR.dom.$doc.ready(function() {
    // 开始装载模块和组件
    SR.lifecycle.mount();
});